export const RBE4_OUTPUT_MASKS = [0b00000001, 0b00000010, 0b00000100, 0b00001000];
export const RBE4_DEFAULT_OUTPUTS_STATUS = [false, false, false, false];
